export type NotificationDialogMessages = {
  deleteNotificationDialogTitle: string;
  deleteNotificationDialogContent: string;
  deleteNotificationDialogCancel: string;
  deleteNotificationDialogConfirm: string;
  detailsDialogTitle: string;
  detailsDialogClose: string;
};

export const NOTIFICATION_DIALOG_MESSAGES: NotificationDialogMessages = {
  deleteNotificationDialogTitle: "Remover Notificação",
  deleteNotificationDialogContent: "Você tem certeza que deseja remover esta notificação?",
  deleteNotificationDialogCancel: "Cancelar",
  deleteNotificationDialogConfirm: "Confirmar",
  detailsDialogTitle: "Detalhes da Notificação",
  detailsDialogClose: "Fechar",
};

export default NOTIFICATION_DIALOG_MESSAGES;
